module.exports = __webpack_public_path__ + "img/book-04.7c64047b.png";